import { bindActionCreators, Dispatch } from "redux";

import { actions as salvationsActions } from "./salvations";
import { actions as eTeamsActions } from "./eteams";
import { actions as mainActions } from "./main/";
import { actions as egroupsActions } from "./egroups/";
import { actions as baptismsActions } from "./baptisms/";
import { actions as watchPartyActions } from "./watchParty/";
import { actions as eventsActions } from "./events";
import { ReducerType } from "./rootReducer";

// In this file the Redux actions and the Redux store are mapped to the default props so they are accessible
// across all the app
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        actions: {
            main: bindActionCreators(mainActions, dispatch),
            eGroups: bindActionCreators(egroupsActions, dispatch),
            baptisms: bindActionCreators(baptismsActions, dispatch),
            eTeams: bindActionCreators(eTeamsActions, dispatch),
            events: bindActionCreators(eventsActions, dispatch),
            salvations: bindActionCreators(salvationsActions, dispatch),
            watchParties: bindActionCreators(watchPartyActions, dispatch),
        },
    };
};

const mapStateToProps = (state: ReducerType) => {
    return state;
};

export { mapDispatchToProps, mapStateToProps };
